export const Locale = {
    EN: 'en',
    FR: 'fr',
} as const;

export type LocaleType = (typeof Locale)[keyof typeof Locale];
